var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgExport = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.58 12.9985C17.7156 12.9965 17.8459 13.0508 17.94 13.1485L18.14 13.3485C18.2347 13.4424 18.2879 13.5702 18.2879 13.7035C18.2879 13.8368 18.2347 13.9646 18.14 14.0585L12.35 19.8485C12.2593 19.9452 12.1326 20 12 20C11.8674 20 11.7407 19.9452 11.65 19.8485L5.86 14.0585C5.76534 13.9646 5.7121 13.8368 5.7121 13.7035C5.7121 13.5702 5.76534 13.4424 5.86 13.3485L6.06 13.1485C6.15408 13.0508 6.28441 12.9965 6.42 12.9985L9 12.9985L9 7.49848C9 7.22234 9.22386 6.99848 9.5 6.99848L14.5 6.99848C14.7761 6.99848 15 7.22234 15 7.49848L15 12.9985L17.58 12.9985ZM5 3.49848L5 4.49848C5 4.77462 5.22386 4.99848 5.5 4.99848L18.5 4.99848C18.7761 4.99848 19 4.77462 19 4.49848L19 3.49848C19 3.22234 18.7761 2.99848 18.5 2.99848L5.5 2.99848C5.22386 2.99848 5 3.22234 5 3.49848Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgExport, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/export.74b2986a.svg";
export { ForwardRef as ReactComponent };